import Controller from 'controllers/controller';
import LazyLoad from 'tools/lazy-load';
import Helpers from 'tools/helpers';

class LazyLoadController extends Controller {
    ready() {
        this.lazyLoad = LazyLoad;
        this.lazyLoad.init();
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.app.on('dom-change', this.init);
        // this.app.loaderController.on('page-loaded', Helpers.throttledFunction(250, this.onPageLoaded))
    }

    init() {
        this.lazyLoad.domHasChanged();
        this.lazyLoad.load('on-load');
    }
}

export default LazyLoadController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/lazy-load.js